import React, { Component, Fragment } from "react";
import { withStyles } from "@mui/styles";
import { connect } from "react-redux";
import SimpleModalWrapped from "../common/Modal";
import { timeZonesTypes } from "./../Attributes/timezone";
import { checkPrivileges } from "../../Helpers";
import {
  EditAccountDetailsSection,
  UserTypeSection,
  CreateAccountDetailsSection,
  UserIdentitySection,
  PreferencesSection,
  PermissionsSection,
  AttributesSection,
  getUserTypeOptions,
  defaultTimezoneOptions,
  selectMe,
} from "./addAccountForm";
import "../Users/usersModal.scss";

let themecolors;
const mapStateToProps = (state) => {
  themecolors = state.themecolors;
  return {
    themecolors: state.themecolors,
  };
};

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  dense: {
    marginTop: 19,
  },
  menu: {
    width: 200,
  },
  button: {
    margin: theme.spacing(1),
  },
  grid: {
    width: "60%",
  },
  label: {
    marginTop: -4,
  },
  shrink: {
    marginTop: 0,
  },
  focused: {
    marginTop: 0,
  },
  margin: {
    margin: theme.spacing(1),
  },
  cssLabel: {
    "&$cssFocused": {
      color: themecolors[500],
    },
  },
  cssFocused: {},
  cssUnderline: {
    "&:after": {
      borderBottomColor: themecolors[500],
    },
  },
  cssOutlinedInput: {
    "&$cssFocused $notchedOutline": {
      borderColor: themecolors[500],
    },
  },
  notchedOutline: {},
  input: {
    padding: "12px 14px 12px",
  },
});

class addAccountModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      at_modal_visable: false,
      resultMessage: "",
      showPassword: false,
      showButton: this.props.editOption ? true : false,
    };
    this.searchFromZoneList = this.searchFromZoneList.bind(this);
  }

  async searchFromZoneList(inputValue) {
    if (!inputValue) {
      return [];
    }

    let result = timeZonesTypes.filter((i) =>
      i.key.toLowerCase().includes(inputValue.toLowerCase()),
    );

    return result.map((item) => {
      return { id: item.key, key: item.key, label: item.key, value: item.key };
    });
  }

  searchAccountManagersList = (inputValue) => {
    this._accountManagerSearchInput = inputValue || "";
    if (this._accountManagerSearchTimer) {
      clearTimeout(this._accountManagerSearchTimer);
    }
    if (!this._accountManagerSearchPromise) {
      this._accountManagerSearchPromise = new Promise((resolve) => {
        this._accountManagerSearchResolve = resolve;
      }).finally(() => {
        this._accountManagerSearchPromise = null;
        this._accountManagerSearchResolve = null;
      });
    }
    this._accountManagerSearchTimer = setTimeout(async () => {
      const search = this._accountManagerSearchInput || "";
      const resolve = this._accountManagerSearchResolve;
      try {
        const response = await fetch(
          `/api/users/getAllUsersInSystem?search=${encodeURIComponent(
            search,
          )}&userTypes=4`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          },
        );
        if (!response.ok) {
          resolve?.([]);
          return;
        }
        const res = await response.json();
        if (res?.statusCode === "440") {
          window.location.replace("/login");
          resolve?.([]);
          return;
        }
        if (res.status !== "success") {
          resolve?.([]);
          return;
        }
        const list = Array.isArray(res?.data?.data)
          ? res.data.data
          : Array.isArray(res?.data)
            ? res.data
            : [];
        resolve?.(
          list.map((item) => {
            const entity = item?.entity || item;
            return {
              id: entity.id,
              label: entity.label || entity.name,
              name: entity.label || entity.name,
              value: entity.id,
            };
          }),
        );
      } catch (e) {
        console.log("e =", e);
        resolve?.([]);
      }
    }, 400);
    return this._accountManagerSearchPromise;
  };

  searchAccountsList = async (inputValue) => {
    if (!inputValue) {
      return [];
    }
    let fetchapi = `/api/accounts/all?accountId=${this.props.logInUser.accountId}&search=${inputValue}&limit=100`;
    if (this.props.logInUser.userType === -1) {
      fetchapi = `/api/accounts/all?accountId=${this.props.logInUser.accountId}&all=true&search=${inputValue}&limit=100`;
    }
    let response = await fetch(fetchapi, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    let json = await response.json();
    let result =
      (await json.data.data) &&
      json.data.data.map((item) => ({
        ...item,
        label: item.label || item.name,
        value: item.id,
      }));
    if (result.length === 0) {
      this.setState({
        resultMessage: "No option found",
      });
    } else {
      this.setState({
        resultMessage: "",
      });
    }

    if (json.hasNext) {
      result.push({
        value: null,
        isDisabled: true,
        label: "Search for more.",
      });
    }
    return result;
  };

  searchVehicleList = async (inputValue) => {
    if (!inputValue) {
      return [];
    }
    let fetchapi = `/api/vehicles/list?userId=${this.props.logInUser.id}&page=1&limit=100&search=${inputValue}`;
    if (this.props.logInUser.userType === -1) {
      fetchapi = `/api/vehicles/list?userId=${this.props.logInUser.id}&page=1&limit=100&search=${inputValue}`;
    }
    let response = await fetch(fetchapi, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    let json = await response.json();
    let result =
      (await json.data.data) &&
      json.data.data.map((item) => ({
        ...item,
        label: item.label || item.name,
        value: item.id,
      }));
    if (result.length === 0) {
      this.setState({
        resultMessage: "No option found",
      });
    } else {
      this.setState({
        resultMessage: "",
      });
    }

    if (json.hasNext) {
      result.push({
        value: null,
        isDisabled: true,
        label: "Search for more.",
      });
    }
    return result;
  };

  searchUsersList = async (inputValue) => {
    if (!inputValue) {
      return [];
    }
    let fetchapi = `/api/users/list?accountId=${this.props.form.accountId}&search=${inputValue}&limit=100`;
    if (this.props.logInUser.userType === -1) {
      fetchapi = `/api/users/list?userId=${this.props.logInUser.accountId}&all=true&search=${inputValue}&limit=100`;
    }
    let response = await fetch(fetchapi, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    let json = await response.json();
    let result =
      (await json.data.data) &&
      json.data.data.map((item) => ({
        ...item,
        label: item.label || item.name,
        value: item.id,
      }));
    if (result.length === 0) {
      this.setState({
        resultMessage: "No option found",
      });
    } else {
      this.setState({
        resultMessage: "",
      });
    }

    if (json.hasNext) {
      result.push({
        value: null,
        isDisabled: true,
        label: "Search for more.",
      });
    }
    return result;
  };

  toggleRoles = (e) => {
    this.setState({
      showButton: !this.state.showButton,
    });
    return this.props.handleChange("roleId")(e);
  };

  handleTogglePassword = () => {
    this.setState({
      showPassword: !this.state.showPassword,
    });
  };

  handleToggleConfirmPassword = () => {
    this.setState({
      showConfirmPassword: !this.state.showConfirmPassword,
    });
  };

  getSectionProps = () => ({
    ...this.props,
    ...this.state,
    userTypeArray: getUserTypeOptions(this.props.userType),
    defaultZones: defaultTimezoneOptions(),
    searchFromZoneList: this.searchFromZoneList,
    searchAccountManagersList: this.searchAccountManagersList,
    searchAccountsList: this.searchAccountsList,
    searchUsersList: this.searchUsersList,
    searchVehicleList: this.searchVehicleList,
    toggleRoles: this.toggleRoles,
    handleTogglePassword: this.handleTogglePassword,
    handleToggleConfirmPassword: this.handleToggleConfirmPassword,
    selectMe,
  });

  render() {
    const sectionProps = this.getSectionProps();

    return (
      <Fragment>
        <SimpleModalWrapped
          {...this.props}
          visable={true}
          translate={this.props.translate}
          isButtonVisable={checkPrivileges("userUpdate")}
          isNotShowAttributesBtn={true}
          title={this.props.addOption ? "sharedRequired" : ""}
          filesDataPrepare={this.props.filesDataPrepare}
          addAttributes={this.addAttributes}
          modalControle={this.props.modalControle}
          buttonText={this.props.buttonText}
          btnclosetext="sharedBack"
          notVisableBackbtn={this.props.notVisableBackbtn}
          editOption={this.props.editOption}
          isVisableBtn={true}
          content={
            <Fragment>
              <EditAccountDetailsSection {...sectionProps} />
              <UserTypeSection {...sectionProps} />
              <CreateAccountDetailsSection {...sectionProps} />
              {!this.props.editOption && this.props.function === "addNew" && (
                <>
                  <UserIdentitySection {...sectionProps} />
                  <PreferencesSection {...sectionProps} />
                  <PermissionsSection {...sectionProps} />
                  <AttributesSection {...sectionProps} />
                </>
              )}
            </Fragment>
          }
        />
      </Fragment>
    );
  }
}

export default connect(mapStateToProps)(withStyles(styles)(addAccountModal));
